/**
 * Questa è la classe per il Repository che riguarda i servizi per gli orari della prestazione scelta
 * Quindi tutte le richieste ai servizi che c'entrano con gli orari andrebbe messa qui
 *
 */

import axios, { AxiosResponse } from "axios";
import axiosRetry from "axios-retry";
import moment from "moment";

import {
	IGetOrariRequest,
	IGetOrariResponse,
	IOrario,
	IOrarioJSON,
	
	IDisponibilitaResiduaResponse,
} from "core/interfaces/data/IOrariRequest";
// serve per settare i cookie in risposta
axiosRetry(axios, {
	retries: 2,
});

// serve per settare i cookie in risposta
axios.defaults.withCredentials = true;

class OrariRepository {
	/**
	 * Metodo che ritorna gli orari disponibili per la prestazione scelta
	 * Le props, ovvero i parametri che servono per fare la richiesta li dichiaro
	 * con una interfaccia che contiene i campi che servono per chiamare il servizio
	 * Nella richiesta di Axios gli do il tipo così puoi usare l'intellisense
	 * Rispetto ai dati che hai messo nella Response crei l'interfaccia che mappa quei campi
	 */
	async getOrari(props: IGetOrariRequest): Promise<IOrario[] | undefined> {
		const url = `${window.CONFIG.REACT_APP_WS_HSB}/OperatorsAvailabilityGetList`;

		try {
			const res = await axios.post<IGetOrariRequest, AxiosResponse<IGetOrariResponse>>(url, props);
			if (res.data.Errors) {
				throw new Error(JSON.stringify(res.data.Errors[0]));
			}

			const json: IOrarioJSON[] = JSON.parse(res.data.DisponibilitaOperatori);

			const orari: IOrario[] = json.map((orario) => {
				return {
					Professionista: { IdOperatore: orario.IdOperatore, DsOperatore: orario.DsOperatore, Generico: orario.Generico },
					Da: moment(orario.Da).toDate(),
					A: moment(orario.A).toDate(),
				};
			});

			return orari;
		} catch (err) {
			console.log(err);
		}
	}

	async getDisponibilitaResidua(props: IGetOrariRequest): Promise<Date[] | undefined> {
		const url = `${window.CONFIG.REACT_APP_WS_HSB}/OperatorsResidualAvailabilityGetList`;

		try {
			const res = await axios.post<IGetOrariRequest, AxiosResponse<IDisponibilitaResiduaResponse>>(url, props);

			if (res.data.Errors) {
				throw new Error(JSON.stringify(res.data.Errors[0]));
			}

			const dateDisponibili: Date[] = JSON.parse(res.data.DisponibilitaResiduaOperatori);

			return dateDisponibili.map((data) => {
				return data.toString().toDateWS();
			});
		} catch (err) {
			console.log(err);
		}
	}
}
var OrariRep=new OrariRepository()
export default OrariRep;
